export const INIT_GET = 'INIT_GET'
export const INIT_ACCESS_CACHE = 'INIT_ACCESS_CACHE'
export const INIT_STATUS = 'INIT_STATUS'



// WEBPACK FOOTER //
// ./src/store/actions/init.js